module.exports = __webpack_public_path__ + "img/e.aae5c46b.jpg";